import { assign, createMachine } from "xstate";
import {
  fetchOrchestrators,
  IMultiOrderOrchestrator,
} from "@nju/data-access-portal-orchestrator";

interface IContext {
  isLoggedIn: boolean;
  multiOrderOrchestrator: IMultiOrderOrchestrator | undefined;
}

type IEvent =
  | {
      type: "FETCH_ORCHESTRATOR_SUCCESS";
      orchestrator: IMultiOrderOrchestrator | undefined;
    }
  | { type: "FETCH_ORCHESTRATOR_ERROR" }
  | { type: "SUBMIT" };

export const tripodBannerMachine = createMachine<IContext, IEvent>(
  {
    context: {
      isLoggedIn: false,
      multiOrderOrchestrator: undefined,
    },
    schema: {
      context: {} as IContext,
      events: {} as IEvent,
    },
    initial: "loading",
    states: {
      loading: {
        always: [
          {
            cond: "isLoggedIn",
            target: "fetchOrchestrators",
          },
          {
            target: "ready",
          },
        ],
      },
      fetchOrchestrators: {
        invoke: {
          src: "fetchOrchestrator",
        },
        on: {
          FETCH_ORCHESTRATOR_SUCCESS: {
            actions: "setOrchestrator",
            target: "ready",
          },
          FETCH_ORCHESTRATOR_ERROR: {
            target: "error",
          },
        },
      },
      ready: {
        on: {
          SUBMIT: {
            actions: "redirectToNextStep",
            target: "success",
          },
        },
      },
      success: {
        type: "final",
      },
      error: {
        type: "final",
      },
    },
  },
  {
    guards: {
      isLoggedIn: ({ isLoggedIn }) => {
        return isLoggedIn;
      },
    },
    actions: {
      setOrchestrator: assign((context, event) => {
        if (event.type === "FETCH_ORCHESTRATOR_SUCCESS") {
          return {
            multiOrderOrchestrator: event.orchestrator,
          };
        }
        return context;
      }),
    },
    services: {
      fetchOrchestrator: () => {
        return async (callback) => {
          try {
            const result = (await fetchOrchestrators()).unwrap();

            return callback({
              type: "FETCH_ORCHESTRATOR_SUCCESS",
              orchestrator: result.multiOrder,
            });
          } catch {
            return callback({ type: "FETCH_ORCHESTRATOR_ERROR" });
          }
        };
      },
    },
  },
);
